export const mentalHealthRoutes = [
    {
        path: '/',
        component: () => import("../pages/index.vue"),
        meta: {
            auth:true
        },
        children: [
             {
                path: '/test',
                name: 'test',
                component: () => import('../pages/test.vue')
            }, {
                path: '/testTeacher',
                name: 'testTeacher',
                component: () => import('../pages/testTeacher.vue')
            }, {
                path: '/mentalStudent',
                name: 'mentalStudent',
                component: () => import('../pages/student.vue')
            }, {
                path: '/startTest',
                name: 'startTest',
                component: () => import('../pages/startTest.vue')
            }, {
                path: '/testResult',
                name: 'testResult',
                component: () => import('../pages/testResult.vue')
            },{
                path: '/statisticsAnalysis',
                name: 'statisticsAnalysis',
                component: () => import('../pages/statisticsAnalysis.vue')
            },
            {
                path: '/estimate',
                name: 'estimate',
                component: () => import('../pages/estimate.vue')
            },
            {
                path: '/estimateParent',
                name: 'estimateParent',
                component: () => import('../pages/estimateParent.vue')
            },
            {
                path: '/estimateIntro',
                name: 'estimateIntro',
                component: () => import('../pages/estimateIntro.vue')
            },
            {
                path: '/estiQuestion',
                name: 'estiQuestion',
                component: () => import('../pages/estiQuestion.vue')
            },
            {
                path: '/primaryTeacherTestIndex',
                name: 'primaryTeacherTestIndex',
                component: () => import('../pages/primaryTeacherTestIndex.vue')
            },
            {
                path: '/primaryTestIndex',
                name: 'primaryTestIndex',
                component: () => import('../pages/primaryTestIndex.vue')
            },
            {
                path: '/priOrmidTest',
                name: 'priOrmidTest',
                component: () => import('../pages/priOrmidTest.vue')
            },
            {
                path: '/popularScience',
                name: 'popularScience',
                component: () => import('../pages/popularScience.vue')
            },
            {
                path: '/singleTestIndex',
                name: 'singleTestIndex',
                component: () => import('../pages/singleTestindex.vue')
            },
            {
                path: '/oneWayAnalysis',
                name: 'oneWayAnalysis',
                component: () => import('../pages/oneWayAnalysis.vue')
            },
            {
                path: '/singleTestintro',
                name: 'singleTestintro',
                component: () => import('../pages/singleTestintro.vue')
            },
            {
                path: '/singleQuestion',
                name: 'singleQuestion',
                component: () => import('../pages/singleQuestion.vue')
            },
            {
                path: '/singleResult',
                name: 'singleResult',
                component: () => import('../pages/singleResult.vue')
            },
            {
                path: '/popularAudio',
                name: 'popularAudio',
                component: () => import('../pages/popularAudio.vue')
            },
            {
                path: '/popularArticle',
                name: 'popularArticle',
                component: () => import('../pages/popularArticle.vue')
            },
            {
                path: '/popularArticleDetail',
                name: 'popularArticleDetail',
                component: () => import('../pages/popularArticleDetail.vue')
            },
            {
                path: '/popularvideo',
                name: 'popularvideo',
                component: () => import('../pages/popularvideo.vue')
            },
            {
                path: '/popularAudioDetail',
                name: 'popularAudioDetail',
                component: () => import('../pages/popularAudioDetail.vue')
            },
            {
                path: '/testRecord',
                name: 'testRecord',
                component: () => import('../pages/testRecord.vue')
            }
        ]

    },
    // {
    //     path: '/mentalStudent',
    //     component: () => import("../pages/student.vue"),
    //     meta: {
    //         auth: true
    //     },
    // },
]